// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_alliance_form-module .cover-container {\n  margin-top: 20px;\n  max-height: 300px;\n  overflow: auto; }\n  .modal_alliance_form-module .cover-container img {\n    width: 100%; }\n", ""]);
// Exports
module.exports = exports;
